import { render, staticRenderFns } from "./CommentTile.vue?vue&type=template&id=4e2aaea4&scoped=true&lang=pug&"
import script from "./CommentTile.vue?vue&type=script&lang=js&"
export * from "./CommentTile.vue?vue&type=script&lang=js&"
import style0 from "./CommentTile.vue?vue&type=style&index=0&id=4e2aaea4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2aaea4",
  null
  
)

export default component.exports